import './index.css'

const Home = () => (
  <div className="main-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/home-blog-img.png"
      alt="home"
      width="250px"
      className="img"
    />
    <h1 className="main-text">Home</h1>
  </div>
)

export default Home
